export const isLessOrEq =
  (min: number) =>
  (value: number): boolean =>
    value <= min

export const isInBetween =
  (start: number, end: number) =>
  (value: number): boolean =>
    value >= start && value <= end
